import { getByPath } from "@restspace/schema-form"


export function constructPath(schema: object, value: object): string {
    if (!schema["pathPattern"]) {
        throw "No pathPattern attribute supplied on schema";
    }

    const pattern: string = schema['pathPattern'];

    return pattern.replace(/\$\{([^}]*)\}/gi, (_, p1) => getByPath(value, p1.split('.')) || '');
}

export function getContentType(schema: object): string {
    if (!schema['contentType']) {
        throw({ show: true, message: "The stored schema is missing a contentType field" });
    }
    return schema['contentType'];
}